export const styles = () => ({
  container: {
    position: 'absolute',
    top: 65,
    padding: '4px 8px',
    zIndex: 99,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    transition: 'opacity ease-out .2s',
    color: '#fff',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
    background: 'rgba(53, 64, 82, 1)',

    '&:hover': {
      background: 'rgba(53, 64, 82, 1)',
    },
  },
  mainText: {
    color: 'rgba(255, 255, 255, 0.7)',

    '& span': {
      color: '#fff',
      fontWeight: 600,
    },
    '& svg': {
      marginLeft: 4,
    },
  },
  button: {
    display: 'block',
    cursor: 'pointer',
    position: 'relative',
    border: 'none',
    background: 'none',
    color: '#fff',
    padding: 0,
    fontSize: 12,

    '&:after': {
      position: 'absolute',
      bottom: -1,
      left: 0,
      background: '#fff',
      width: '100%',
      height: '1px',
      content: "''",
      display: 'block',
    },
  },
})
